import {
  FormControl,
  FormControlLabel,
  Grid,
  OutlinedInput,
  Radio,
  RadioGroup,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InputMask from "react-text-mask";
import BasicInput from "../../../component/input/basic-input/BasicInput";
import { Member } from "../../../models/data/members/Member";
import MemberSectionType from "../../../models/types/memberSectionTypes/memberSectionType";
import { usePersonalDataSectionStyles } from "./personalDataSectionStyles";

interface Props {
  member: Member;
  onChange: any;
}

export const MemberPersonalData = ({ member, onChange }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = usePersonalDataSectionStyles();

  const [jmbgValue, setJmbgValue] = useState("");
  const handleOnKeyPressed = (
    event: React.KeyboardEvent<HTMLInputElement>,
    id: string
  ) => {
    if (event.key === "Enter") {
      console.log("Enter key pressed");
      switch (id) {
        case "memberPersonalData_input-firstName":
          console.log("firstName field");
          var firstNameField = document.getElementById(
            "memberPersonalData_input-firstName"
          );
          firstNameField?.focus();
          break;
        case "memberPersonalData_input-parentName":
          console.log("parentName field");
          var parentNameField = document.getElementById(
            "memberPersonalData_input-parentName"
          );
          parentNameField?.focus();
          break;
        case "memberPersonalData_input-lastName":
          console.log("parentName field");
          var lastNameField = document.getElementById(
            "memberPersonalData_input-lastName"
          );
          lastNameField?.focus();
          break;
        case "memberPersonalData_input-birthDate":
          console.log("parentName field");
          var birthDateField = document.getElementById(
            "memberPersonalData_input-birthDate"
          );
          birthDateField?.focus();
          break;
        case "memberPersonalData_input-birthPlace":
          console.log("parentName field");
          var birthPlaceField = document.getElementById(
            "memberPersonalData_input-birthPlace"
          );
          birthPlaceField?.focus();
          break;
        case "memberPersonalData_input-idNumber":
          console.log("parentName field");
          var idNumberField = document.getElementById(
            "memberPersonalData_input-idNumber"
          );
          idNumberField?.focus();
          break;
        case "memberPersonalData_input-jmbg":
          console.log("parentName field");
          var jmbgField = document.getElementById(
            "memberPersonalData_input-jmbg"
          );
          jmbgField?.focus();
          break;
      }
    }
  };
  const formattedDate = () =>
    member.personalData.birthDate &&
    member.personalData.birthDate.substring(0, 10);

  // useEffect(() => {
  //   const firstNameField = document.getElementById(
  //     "memberPersonalData_input-firstName"
  //   );
  //   if (firstNameField) {
  //     firstNameField.focus();
  //   }
  // }, []);

  return (
    <Grid container spacing={2}>
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <BasicInput
          id="memberPersonalData_input-firstName"
          label={t("memberManagementPage.personalDataFirstName")}
          value={member.personalData.firstName}
          onChange={(e) =>
            onChange(
              e.target.value,
              "firstName",
              MemberSectionType.memberPersonalData
            )
          }
          error={
            member.personalData?.firstName !== null
              ? member.personalData.firstName.length < 3
              : true
          }
          errorMessage={t(
            "memberManagementPage.personalDataErrorMessageFirstName"
          )}
          onKeyDown={(e) =>
            handleOnKeyPressed(e, "memberPersonalData_input-parentName")
          }
        />
      </Grid>

      <Grid item lg={4} md={4} sm={12} xs={12}>
        <BasicInput
          id="memberPersonalData_input-parentName"
          label={t("memberManagementPage.personalDataParentName")}
          value={member.personalData.parentName}
          onChange={(e) =>
            onChange(
              e.target.value,
              "parentName",
              MemberSectionType.memberPersonalData
            )
          }
          onKeyDown={(e) =>
            handleOnKeyPressed(e, "memberPersonalData_input-lastName")
          }
        />
      </Grid>

      <Grid item lg={4} md={4} sm={12} xs={12}>
        <BasicInput
          id="memberPersonalData_input-lastName"
          label={t("memberManagementPage.personalDataLastName")}
          value={member.personalData.lastName}
          onChange={(e) =>
            onChange(
              e.target.value,
              "lastName",
              MemberSectionType.memberPersonalData
            )
          }
          error={
            member.personalData?.lastName?.length !== undefined
              ? member.personalData.lastName.length < 3
              : true
          }
          errorMessage={t(
            "memberManagementPage.personalDataErrorMessageLastName"
          )}
          onKeyDown={(e) =>
            handleOnKeyPressed(e, "memberPersonalData_input-birthDate")
          }
        />
      </Grid>

      <Grid item lg={4} md={4} sm={12} xs={12}>
        <BasicInput
          id="memberPersonalData_input-birthDate"
          type="date"
          label={t("memberManagementPage.personalDataBirthDate")}
          value={formattedDate()}
          onChange={(e) =>
            onChange(
              e.target.value,
              "birthDate",
              MemberSectionType.memberPersonalData
            )
          }
          error={
            member.personalData.birthDate !== null
              ? member.personalData.birthDate.length < 10
              : true
          }
          errorMessage={t(
            "memberManagementPage.personalDataErrorMessageDateofbirth"
          )}
          onKeyDown={(e) =>
            handleOnKeyPressed(e, "memberPersonalData_input-birthPlace")
          }
        />
      </Grid>
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <BasicInput
          id="memberPersonalData_input-birthPlace"
          label={t("memberManagementPage.personalDataBirthPlace")}
          value={member.personalData.birthPlace}
          onChange={(e) =>
            onChange(
              e.target.value,
              "birthPlace",
              MemberSectionType.memberPersonalData
            )
          }
          onKeyDown={(e) =>
            handleOnKeyPressed(e, "memberPersonalData_input-idNumber")
          }
        />
      </Grid>
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <BasicInput
          id="memberPersonalData_input-idNumber"
          label={t("memberManagementPage.personalDataIdNumber")}
          value={member.personalData.idNumber}
          onChange={(e) =>
            onChange(
              e.target.value,
              "idNumber",
              MemberSectionType.memberPersonalData
            )
          }
          onKeyDown={(e) =>
            handleOnKeyPressed(e, "memberPersonalData_input-jmbg")
          }
        />
      </Grid>
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          fullWidth
        >
          <Typography variant="body1" className={classes.inputTitle}>
            {t("memberManagementPage.personalDataUin")}:
          </Typography>
          <OutlinedInput
            id="memberPersonalData_input-jmbg"
            autoComplete="off"
            fullWidth
            type={"text"}
            className={
              jmbgValue.length > 0 && jmbgValue.length < 12
                ? classes.inputError
                : classes.input
            }
            value={member.personalData.jmbg || ""}
            placeholder="0 0 0 0 0 0 0 0 0 0 0 0 0"
            onChange={(e) => {
              const value = e.target.value.replace(/\s/g, "").replace(/_/g, "");
              if (value.length == 13 || value.length == 0) {
                onChange(value, "jmbg", MemberSectionType.memberPersonalData);
              }
            }}
            style={{ background: "transparent" }}
            inputComponent={(props) => (
              <InputMask
                {...props}
                mask={[
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                ]}
              />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item display="flex" alignItems="end">
        <FormControl>
          <RadioGroup name="gender">
            <Grid container>
              <Grid item>
                <FormControlLabel
                  value={
                    member.personalData.gender !== null &&
                    member.personalData.gender === "Muško"
                      ? true
                      : false
                  }
                  checked={
                    member.personalData.gender !== null &&
                    member.personalData.gender === "Muško"
                      ? true
                      : false
                  }
                  control={
                    <Radio
                      id="memberPersonalData_radioButton-male"
                      className={classes.radioButton}
                      onClick={(e) =>
                        onChange(
                          "Muško",
                          "gender",
                          MemberSectionType.memberPersonalData
                        )
                      }
                    />
                  }
                  label={
                    <Typography variant="body1" color={theme.palette.info.dark}>
                      {t("memberManagementPage.personalDataMale")}
                    </Typography>
                  }
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 14,
                    },
                  }}
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  value={
                    member.personalData.gender !== null &&
                    member.personalData.gender === "Žensko"
                      ? true
                      : false
                  }
                  checked={
                    member.personalData.gender !== null &&
                    member.personalData.gender === "Žensko"
                      ? true
                      : false
                  }
                  control={
                    <Radio
                      id="memberPersonalData_radioButton-female"
                      className={classes.radioButton}
                      onClick={(e) =>
                        onChange(
                          "Žensko",
                          "gender",
                          MemberSectionType.memberPersonalData
                        )
                      }
                    />
                  }
                  label={
                    <Typography variant="body1" color={theme.palette.info.dark}>
                      {t("memberManagementPage.personalDataFemale")}
                    </Typography>
                  }
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 14,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};
